import type { ProjectState } from 'app/store/project/project.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectProjectState } from 'app/store/project/project.state';
import * as fromScheduledTasks from './scheduled-tasks.reducer';

export const scheduledTasksState = createSelector(
  selectProjectState,
  state => state.scheduledTasks,
);

export const scheduledTasks = createSelector(
  selectProjectState,
  state => fromScheduledTasks.selectAll(state.scheduledTasks),
);

export const oneScheduledTask = createSelector(
  selectProjectState,
  (state: ProjectState, props: { id: Uuid }) => fromScheduledTasks.selectEntities(state.scheduledTasks)[props.id],
);

export const scheduledTasksLoading = createSelector(
  selectProjectState,
  state => state.scheduledTasks.loading,
);
